<template>
  <v-container class="twilio-whatsapp-shell textoPoppins pa-0" fluid>
    <v-card class="twilio-whatsapp-app elevation-6">
      <v-row class="ma-0 fill-height twilio-whatsapp-row">
        <v-col
          cols="12"
          sm="6"
          class="pa-0 twilio-whatsapp-sidebar"
          :class="{ 'wa-panel-hidden': isMobileLayout && chatActivo }"
        >
          <div class="wa-sidebar-header">
            <div>
              <div class="text-subtitle-2 font-weight-bold">Vendedor IA · Sandbox</div>
              <div class="text-caption grey--text">Simula lead → ves qué respondería la IA V1.0</div>
            </div>
            <div>
              <v-btn
                v-if="esFuenteSandbox"
                icon
                small
                title="Nuevo chat de prueba"
                @click="dialogNuevoChat = true"
              >
                <v-icon small>mdi-plus</v-icon>
              </v-btn>
              <v-btn icon small title="Gates / métodos de pago" :to="{ name: 'vendedorIaPagos' }">
                <v-icon small>mdi-cash-multiple</v-icon>
              </v-btn>
              <v-btn icon small title="Ver diagrama de flujo" @click="dialogDiagrama = true">
                <v-icon small>mdi-sitemap</v-icon>
              </v-btn>
              <v-btn icon small title="Agentes IA" @click="irAgentes">
                <v-icon small>mdi-robot</v-icon>
              </v-btn>
              <v-btn icon small title="Capa comercial INBI" @click="irComercial">
                <v-icon small>mdi-store-cog</v-icon>
              </v-btn>
              <v-btn icon small @click="cargarChats" :loading="cargandoChats">
                <v-icon small>mdi-refresh</v-icon>
              </v-btn>
            </div>
          </div>

          <div class="px-2 pt-2">
            <v-select
              v-model="fuenteChats"
              :items="fuentesChatsItems"
              item-text="text"
              item-value="value"
              dense
              outlined
              hide-details
              label="Fuente de chats"
              @change="onCambioFuente"
            ></v-select>
            <v-select
              v-if="fuenteChats === 'inbi'"
              v-model="filtroMarcaInbi"
              :items="filtrosMarcaInbi"
              dense
              outlined
              hide-details
              class="mt-2"
              label="Ciudad INBI"
              @change="cargarChats"
            ></v-select>
          </div>

          <v-alert v-if="fuenteChats === 'sandbox' && config && !config.enabled" dense outlined type="warning" class="ma-2 mb-0">
            <div class="text-caption">
              Twilio Sandbox no está configurado en el servidor. Agrega
              <code>TWILIO_SANDBOX_ACCOUNT_SID</code> y <code>TWILIO_SANDBOX_AUTH_TOKEN</code> en el .env.
            </div>
          </v-alert>

          <v-alert v-if="syncAviso" dense outlined :type="syncAviso.tipo" class="ma-2 mb-0">
            <div class="text-caption">{{ syncAviso.texto }}</div>
          </v-alert>

          <v-alert dense outlined type="info" class="ma-2 mb-0">
            <div class="text-caption" v-if="esFuenteSandbox">
              <strong>Prueba turbo:</strong> el lead eres <em>tú desde el celular</em>.
              La IA responde y, con <em>Auto-enviar IA a WhatsApp</em>, el mensaje llega a tu teléfono por el Sandbox.
            </div>
            <div class="text-caption" v-else>
              <strong>Shadow:</strong> chats de producción solo lectura.
              Puedes ver contexto y generar borrador; el envío está bloqueado.
            </div>
            <div v-if="fuenteChats === 'sandbox' && config && config.webhookUrl" class="text-caption mt-1">
              Webhook sandbox: <code>{{ config.webhookUrl }}</code>
            </div>
          </v-alert>

          <div class="wa-search-panel">
            <v-text-field
              v-model="buscar"
              dense
              solo
              flat
              rounded
              hide-details
              clearable
              prepend-inner-icon="mdi-magnify"
              placeholder="Buscar número"
              class="wa-search"
            ></v-text-field>
          </div>

          <div id="preguntas" class="wa-chat-list">
            <v-list dense class="py-0">
              <v-list-item
                v-for="chat in chatsFiltrados"
                :key="chatKey(chat)"
                @click="abrirChat(chat)"
                :class="{ 'wa-chat-active': chatActivo && chatKey(chatActivo) === chatKey(chat) }"
              >
                <v-list-item-content>
                  <v-list-item-title class="text-body-2 font-weight-medium">
                    {{ chat.telefono }}
                    <v-chip v-if="chat.label" x-small class="ml-1" label>{{ chat.label }}</v-chip>
                  </v-list-item-title>
                  <v-list-item-subtitle class="text-caption text-truncate">
                    {{ chat.preview || 'Sin mensajes' }}
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <span class="text-caption grey--text">{{ formatearFecha(chat.ultimo_mensaje) }}</span>
                </v-list-item-action>
              </v-list-item>
            </v-list>
            <div v-if="!chatsFiltrados.length && !cargandoChats" class="text-center pa-6 grey--text text-caption">
              {{ emptyChatsTexto }}
            </div>
          </div>
        </v-col>

        <v-col
          cols="12"
          sm="6"
          class="pa-0 twilio-whatsapp-conversation"
          :class="{ 'wa-panel-hidden': isMobileLayout && !chatActivo }"
        >
          <template v-if="chatActivo">
            <div class="wa-chat-header">
              <v-btn v-if="isMobileLayout" icon small class="mr-2" @click="chatActivo = null">
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
              <div>
                <div class="text-subtitle-2 font-weight-bold">{{ chatActivo.telefono }}</div>
                <div v-if="esFuenteSandbox" class="text-caption grey--text">Sandbox · envía a tu WhatsApp</div>
              </div>
              <v-chip
                v-if="controlEstado"
                x-small
                label
                class="ml-2"
                :color="chipControlColor"
              >
                {{ chipControlTexto }}
              </v-chip>
              <v-spacer></v-spacer>
              <v-btn
                icon
                small
                title="Copiar conversación JSON"
                :loading="exportandoJsonConversacion === 'copiar'"
                @click="copiarConversacionJson"
              >
                <v-icon small>mdi-content-copy</v-icon>
              </v-btn>
              <v-btn
                icon
                small
                title="Descargar conversación JSON"
                :loading="exportandoJsonConversacion === 'descargar'"
                @click="descargarConversacionJson"
              >
                <v-icon small>mdi-file-download-outline</v-icon>
              </v-btn>
              <v-btn
                v-if="esFuenteSandbox"
                icon
                small
                color="error"
                title="Limpiar (Fase 3 / Fase 2 / todo)"
                :loading="limpiandoChat"
                @click="confirmarLimpiarConversacion"
              >
                <v-icon small>mdi-delete-sweep</v-icon>
              </v-btn>
              <v-btn icon small @click="refrescarMensajes(false, { syncTwilio: true })" :loading="cargandoMensajes">
                <v-icon small>mdi-refresh</v-icon>
              </v-btn>
            </div>

            <div id="scroll-target" class="wa-messages-panel">
              <div
                v-for="(msg, i) in mensajes"
                :key="msg.id || i"
                class="wa-message-row"
                :class="msg.mio ? 'wa-message-out' : 'wa-message-in'"
              >
                <div class="wa-bubble">
                  <div v-if="msg.es_ubicacion" class="wa-audio-badge text-caption mb-1">
                    <v-icon x-small color="teal">mdi-map-marker</v-icon>
                    Ubicación
                  </div>
                  <div v-else-if="msg.es_documento_bloqueado" class="wa-audio-badge text-caption mb-1">
                    <v-icon x-small color="orange darken-2">mdi-file-cancel</v-icon>
                    Archivo no soportado
                  </div>
                  <div v-else-if="msg.es_sticker" class="wa-audio-badge text-caption mb-1">
                    <v-icon x-small color="pink">mdi-sticker-emoji</v-icon>
                    Sticker
                  </div>
                  <div v-else-if="msg.es_imagen" class="wa-audio-badge text-caption mb-1">
                    <v-icon x-small color="deep-purple">mdi-image</v-icon>
                    Imagen analizada
                  </div>
                  <div v-else-if="msg.es_audio" class="wa-audio-badge text-caption mb-1">
                    <v-icon x-small color="indigo">mdi-microphone</v-icon>
                    Audio transcrito
                  </div>
                  <div style="white-space: pre-line">{{ msg.mensaje || (msg.es_ubicacion ? '(ubicación sin detalle — refresca)' : '(sin texto)') }}</div>
                  <div class="wa-bubble-meta">{{ formatearFecha(msg.fecha_creacion) }}</div>
                </div>
              </div>
            </div>

            <div class="wa-draft-panel" :class="{ 'wa-draft-panel--min': panelIaMinimizado }">
              <div class="wa-ia-bar px-2">
                <span class="wa-ia-title">IA</span>
                <span class="wa-ia-agent text-truncate" :title="etiquetaAgenteBarra">{{ etiquetaAgenteBarra }}</span>
                <v-chip
                  v-if="modoOperacionAgente && modoOperacionAgente !== 'autonomo_sandbox'"
                  x-small
                  label
                  class="ml-1"
                  :color="chipModoColor"
                >{{ chipModoTextoCorto }}</v-chip>
                <v-spacer />
                <v-btn
                  x-small
                  color="indigo"
                  dark
                  class="mr-1"
                  :loading="generandoBorrador"
                  :disabled="iaBloqueadaPorHumano"
                  @click="generarBorradorIa"
                >{{ panelIaMinimizado ? 'IA' : 'Responder' }}</v-btn>
                <v-menu offset-y left :close-on-content-click="false">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon x-small v-bind="attrs" v-on="on" title="Ajustes IA">
                      <v-icon small>mdi-cog-outline</v-icon>
                    </v-btn>
                  </template>
                  <v-card min-width="280" class="pa-3">
                    <div class="text-caption font-weight-bold mb-2">Quién responde</div>
                    <v-select v-model="marcaPrompt" :items="marcasPrompt" label="Marca" dense outlined hide-details class="mb-2" menu-props="offset-y" />
                    <v-select v-model="idAgenteSeleccionado" :items="agentesSelectItems" label="Agente" dense outlined hide-details clearable class="mb-2" menu-props="offset-y" @change="onCambioIdAgenteSandbox" />
                    <v-select v-if="versionesAgenteItems.length" v-model="versionAgenteSeleccionada" :items="versionesAgenteItems" label="Versión" dense outlined hide-details clearable class="mb-3" menu-props="offset-y" @change="onCambioAgenteSandbox" />
                    <v-divider class="mb-2" />
                    <v-btn v-if="mostrarBotonTomarControl" block small outlined color="orange darken-2" class="mb-1" :loading="accionControl" @click="tomarControlConversacion">Tomar control</v-btn>
                    <v-btn v-if="mostrarBotonDevolverIa" block small outlined color="teal" class="mb-1" :loading="accionControl" @click="devolverControlIa">Devolver a IA</v-btn>
                    <v-btn block small text :loading="cargandoContexto" @click="cargarContextoIa(); tabIa = 0">Cargar contexto</v-btn>
                    <v-btn block small text :disabled="!jsonContextoIa" @click="copiarContextoIaJson">Copiar JSON</v-btn>
                    <v-btn block small text @click="panelIaMinimizado = false; tabIa = 2">Abrir Lab</v-btn>
                  </v-card>
                </v-menu>
                <v-btn icon x-small :title="panelIaMinimizado ? 'Expandir' : 'Minimizar'" @click="panelIaMinimizado = !panelIaMinimizado">
                  <v-icon small>{{ panelIaMinimizado ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                </v-btn>
              </div>

              <template v-if="!panelIaMinimizado">
                <v-tabs v-model="tabIa" dense height="32" background-color="transparent" class="wa-ia-tabs px-1">
                  <v-tab class="text-caption">Ctx</v-tab>
                  <v-tab class="text-caption">Borrador</v-tab>
                  <v-tab class="text-caption">Lab</v-tab>
                </v-tabs>
                <v-tabs-items v-model="tabIa" class="wa-ia-tabs-items">
                  <v-tab-item>
                    <div v-if="contextoActivo" class="wa-contexto-box ma-1">
                      <div class="d-flex align-center mb-1">
                        <span class="text-caption grey--text text-truncate">
                          {{ contextoActivo.marca && (contextoActivo.marca.marcaPrompt || contextoActivo.marca.label) }}
                          · {{ contextoActivo.conversacion && contextoActivo.conversacion.mensajes_en_contexto }}/{{ contextoActivo.conversacion && contextoActivo.conversacion.total_mensajes }}
                        </span>
                        <v-spacer />
                        <v-btn x-small icon :disabled="!jsonContextoIa" @click="copiarContextoIaJson"><v-icon x-small>mdi-content-copy</v-icon></v-btn>
                      </div>
                      <pre class="wa-contexto-pre mb-0">{{ contextoIaResumen }}</pre>
                    </div>
                    <div v-else class="text-caption grey--text text-center pa-3">⚙ → Cargar contexto</div>
                  </v-tab-item>
                  <v-tab-item>
                    <div v-if="borradorActivo" class="wa-draft-box ma-1">
                      <div class="wa-draft-text">{{ borradorActivo.borrador || borradorActivo.texto }}</div>
                      <div v-if="textoParaEnviarWhatsApp(borradorActivo)" class="mt-2">
                        <div class="wa-draft-wa">{{ textoParaEnviarWhatsApp(borradorActivo) }}</div>
                        <v-btn v-if="esFuenteSandbox" x-small color="primary" class="mt-1" :loading="enviando" @click="enviarBorradorAWhatsApp">Enviar WA</v-btn>
                      </div>
                    </div>
                    <div v-else class="text-caption grey--text text-center pa-3">Sin borrador · <strong>Responder</strong></div>
                  </v-tab-item>
                  <v-tab-item>
                    <div class="ma-2 wa-lab-scroll">
                      <v-row dense>
                        <v-col cols="6">
                          <v-text-field v-model.number="delayAutoIaSegundos" type="number" min="0" dense outlined hide-details label="Delay IA (s)" @change="persistirLabConfig" />
                        </v-col>
                        <v-col cols="6">
                          <v-text-field v-model.number="delaySeguimientoMinutos" type="number" min="0" dense outlined hide-details label="Seg. (min)" @change="persistirLabConfig" />
                        </v-col>
                      </v-row>
                      <div class="d-flex flex-wrap mt-2 mb-1">
                        <v-btn x-small outlined class="mr-1 mb-1" :loading="labCargando" :disabled="!idConversacionActiva" @click="programarSeguimientoLab">Programar</v-btn>
                        <v-btn x-small color="orange" dark class="mr-1 mb-1" :loading="labSimulando" :disabled="!idConversacionActiva" @click="simularTiempoPaso">Simular tiempo</v-btn>
                        <v-btn x-small text class="mb-1" :loading="labCargando" :disabled="!idConversacionActiva" @click="cargarSeguimientosLab">Listar</v-btn>
                      </div>
                      <div class="text-caption grey--text mb-1">Pruebas lead · clic = simula mensaje entrante</div>
                      <v-chip v-for="(p, i) in frasesPruebaLab" :key="i" x-small class="ma-1" outlined @click="enviarFrasePruebaLab(p)" :disabled="labEnviandoPrueba">{{ p.titulo }}</v-chip>
                      <v-btn x-small color="primary" dark block class="mt-2" :loading="labExportando" :disabled="!chatActivo" @click="descargarEcosistemaMd">Descargar .md</v-btn>
                      <pre v-if="labSeguimientosTexto" class="wa-contexto-pre mt-2 mb-0">{{ labSeguimientosTexto }}</pre>
                    </div>
                  </v-tab-item>
                </v-tabs-items>
              </template>
            </div>

            <template v-if="esFuenteSandbox">
              <div class="wa-compose-bar px-2">
                <v-btn-toggle v-model="rolEnvio" dense mandatory class="wa-role-toggle flex-shrink-0">
                  <v-btn x-small value="asesor_whatsapp" title="WhatsApp"><v-icon x-small>mdi-whatsapp</v-icon></v-btn>
                  <v-btn x-small value="asesor_local" title="Solo pantalla"><v-icon x-small>mdi-monitor</v-icon></v-btn>
                </v-btn-toggle>
                <v-checkbox v-model="autoGenerarIa" dense hide-details class="mt-0 pt-0 ml-1 wa-compose-check" label="Auto-IA" />
                <v-checkbox v-model="autoEnviarIaWhatsApp" dense hide-details class="mt-0 pt-0 ml-1 wa-compose-check" :disabled="esModoAuxiliar || esModoPausado" label="Auto-env" />
                <v-spacer />
                <span v-if="esModoAuxiliar" class="text-caption blue--text">auxiliar</span>
                <span v-else-if="esModoPausado" class="text-caption orange--text">pausado</span>
              </div>
              <div class="wa-compose">
                <v-textarea
                  v-model="textoEnviar"
                  auto-grow
                  rows="1"
                  dense
                  solo
                  flat
                  hide-details
                  :placeholder="placeholderEnvio"
                  class="wa-compose-input"
                  @keydown.enter.exact.prevent="enviarMensaje"
                ></v-textarea>
                <v-btn color="primary" icon :loading="enviando" :disabled="!textoEnviar.trim()" @click="enviarMensaje">
                  <v-icon>mdi-send</v-icon>
                </v-btn>
              </div>
              <v-expansion-panels flat class="px-2 pb-1">
                <v-expansion-panel>
                  <v-expansion-panel-header class="text-caption py-1" style="min-height:28px">Plantilla WA</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-text-field v-model="contentSid" dense outlined hide-details label="contentSid" class="mb-2" />
                    <v-text-field v-model="contentVariables" dense outlined hide-details label='vars JSON' />
                    <v-btn x-small color="indigo" dark class="mt-2" :loading="enviando" @click="enviarPlantilla">Enviar plantilla</v-btn>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </template>

            <v-alert v-else dense text type="warning" class="ma-2">
              <div class="text-caption">
                Fuente <strong>{{ fuenteChats }}</strong>: solo lectura.
                Puedes ver contexto y generar borrador; el envío a WhatsApp está deshabilitado.
              </div>
            </v-alert>
          </template>

          <div v-else class="wa-empty-chat d-flex align-center justify-center fill-height">
            <div class="text-center grey--text">
              <v-icon large color="grey lighten-1">mdi-whatsapp</v-icon>
              <div class="mt-2">Selecciona una conversación</div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-card>

    <v-dialog v-model="dialogDiagrama" max-width="920" scrollable>
      <v-card>
        <v-card-title class="subtitle-1">
          Flujo Twilio Sandbox
          <v-spacer></v-spacer>
          <v-btn icon small @click="dialogDiagrama = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-4">
          <p class="text-body-2 mb-4">
            Entorno de pruebas aislado del Twilio de producción. Puedes simular al lead
            desde esta pantalla (sin WhatsApp) o unirte al sandbox real con
            <code>join {{ config && config.joinCode ? config.joinCode : 'código' }}</code>.
          </p>

          <div class="sandbox-diagram">
            <div class="sandbox-diagram-row">
              <div class="sandbox-node sandbox-node-user">Lead<br><small>simulado o WA</small></div>
              <div class="sandbox-arrow">→</div>
              <div class="sandbox-node sandbox-node-api">BD Sandbox<br><small>+ prompt calificación</small></div>
              <div class="sandbox-arrow">→</div>
              <div class="sandbox-node sandbox-node-ui">Respuesta IA<br><small>borrador (no envía)</small></div>
            </div>

            <div class="sandbox-diagram-steps mt-4">
              <div class="sandbox-step"><strong>1.</strong> Nuevo chat o abre uno existente</div>
              <div class="sandbox-step"><strong>2.</strong> Escribe <em>como Lead</em> → se guarda en BD local</div>
              <div class="sandbox-step"><strong>3.</strong> <strong>¿Qué respondería la IA?</strong> usa prompt de calificación inicial</div>
              <div class="sandbox-step"><strong>4.</strong> Limpia la conversación para reiniciar la prueba</div>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogNuevoChat" max-width="420">
      <v-card>
        <v-card-title class="subtitle-1">Nuevo chat de prueba</v-card-title>
        <v-card-text>
          <v-text-field
            v-model="nuevoChatTelefono"
            dense
            outlined
            label="Teléfono del lead"
            hint="Ej. 5218184715969 o +5218184715969"
            persistent-hint
            @keydown.enter.prevent="crearChatPrueba"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogNuevoChat = false">Cancelar</v-btn>
          <v-btn color="primary" :disabled="!nuevoChatTelefono.trim()" @click="crearChatPrueba">Crear</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogLimpiar" max-width="480">
      <v-card>
        <v-card-title class="subtitle-1">Limpiar conversación</v-card-title>
        <v-card-text>
          <div class="mb-3">
            Peer: <strong>{{ chatActivo && chatActivo.telefono }}</strong>
          </div>
          <v-radio-group v-model="modoLimpiar" hide-details class="mt-0">
            <v-radio value="fase3">
              <template v-slot:label>
                <div>
                  <div class="font-weight-medium">Borrar Fase 3</div>
                  <div class="text-caption grey--text">
                    Conserva hasta la confirmación del examen de ubicación
                    (“ya terminé”) y limpia lo posterior + CTX de Fase 3.
                  </div>
                </div>
              </template>
            </v-radio>
            <v-radio value="fase2" class="mt-3">
              <template v-slot:label>
                <div>
                  <div class="font-weight-medium">Borrar Fase 2</div>
                  <div class="text-caption grey--text">
                    Conserva los datos de perfilamiento (nombre, horario, etc.) y limpia
                    la explicación comercial + CTX de Fase 2.
                  </div>
                </div>
              </template>
            </v-radio>
            <v-radio value="todo" class="mt-3">
              <template v-slot:label>
                <div>
                  <div class="font-weight-medium">Borrar todo</div>
                  <div class="text-caption grey--text">
                    Elimina mensajes, perfil y CTX completo. Hay que volver a llenar Fase 1.
                  </div>
                </div>
              </template>
            </v-radio>
          </v-radio-group>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogLimpiar = false">Cancelar</v-btn>
          <v-btn
            color="error"
            :loading="limpiandoChat"
            @click="limpiarConversacion"
          >
            {{ etiquetaBotonLimpiar }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import mixinTwilioWhatsAppLayout from '@/mixins/mixinTwilioWhatsAppLayout'
import '@/assets/styles/twilio-whatsapp-layout.scss'

export default {
  name: 'TwilioSandbox',
  mixins: [mixinTwilioWhatsAppLayout],

  data: () => ({
    config: null,
    chats: [],
    mensajes: [],
    chatActivo: null,
    buscar: '',
    textoEnviar: '',
    contentSid: '',
    contentVariables: '{"1":"","2":""}',
    cargandoChats: false,
    cargandoMensajes: false,
    enviando: false,
    pollTimer: null,
    dialogDiagrama: false,
    dialogNuevoChat: false,
    dialogLimpiar: false,
    modoLimpiar: 'fase3',
    nuevoChatTelefono: '',
    rolEnvio: 'asesor_whatsapp',
    autoGenerarIa: true,
    autoEnviarIaWhatsApp: true,
    modoOperacionAgente: 'autonomo_sandbox',
    idAgenteSeleccionado: null,
    versionAgenteSeleccionada: null,
    agentesLista: [],
    versionesAgenteActivo: [],
    delayAutoIaSegundos: 0,
    delaySeguimientoMinutos: 1,
    labCargando: false,
    labSimulando: false,
    labExportando: false,
    exportandoJsonConversacion: null,
    labEnviandoPrueba: false,
    labSeguimientosTexto: '',
    frasesPruebaLab: [
      { titulo: 'Precio', texto: '¿Cuánto cuesta el curso?' },
      { titulo: 'Sucursal', texto: '¿Cuál plantel me queda cerca? Vivo en Anáhuac, Monterrey' },
      { titulo: 'Examen', texto: 'Mándame el examen de ubicación' },
      { titulo: 'Info programa', texto: '¿Qué incluye el intensivo presencial?' },
      { titulo: 'Métodos pago', texto: 'Mándame los métodos de pago' },
      { titulo: 'CLABE (debe rechazar)', texto: 'Pásame la CLABE' },
      { titulo: 'Grupos', texto: '¿Hay grupos sabatinos?' },
      { titulo: 'Humano', texto: 'Quiero hablar con una persona' },
    ],
    panelIaMinimizado: true,
    limpiandoChat: false,
    ultimoInboundId: null,
    /** Texto del último inbound (para detectar Whisper que rellena el mismo id) */
    ultimoInboundTexto: null,
    /** Evita doble Auto-IA cuando el poll y otro refresh corren en paralelo */
    iaAutoLock: false,
    /**
     * Lead escribió mientras Auto-IA generaba / durante refresh skipAutoIa.
     * Sin esto, ultimoInboundId ya apunta al mensaje nuevo y el poll no lo retriga.
     */
    inboundPendienteAutoIa: false,
    refrescoMensajesEnCurso: false,
    ultimoSyncTwilioMs: 0,
    inboundIaProcesados: {},
    /** Intentos Auto-IA por inbound; a 2 → bay (evita desfase) */
    inboundIaIntentos: {},
    syncAviso: null,
    fuenteChats: 'sandbox',
    fuentesChatsItems: [
      { value: 'sandbox', text: 'Sandbox (pruebas)' },
      { value: 'inbi', text: 'INBI Unificado' },
      { value: 'fast', text: 'Twilio FAST' },
    ],
    filtroMarcaInbi: 'TODAS',
    filtrosMarcaInbi: [
      { value: 'TODAS', text: 'Todas las ciudades' },
      { value: 'INBI_MTY', text: 'INBI Monterrey' },
      { value: 'INBI_CDMX', text: 'INBI CDMX' },
      { value: 'INBI_GDL', text: 'INBI Guadalajara' },
    ],
    marcaPrompt: 'INBI_MTY',
    marcasPrompt: ['INBI_MTY', 'INBI_CDMX', 'INBI_GDL', 'FAST'],
    generandoBorrador: false,
    cargandoContexto: false,
    borradorActivo: null,
    borradores: [],
    contextoActivo: null,
    perfilActivo: null,
    tabIa: 0,
    controlEstado: null,
    cargandoControl: false,
    accionControl: false,
  }),

  computed: {
    telefonoSandbox() {
      if (!this.config || !this.config.from) return '+14155238886'
      return String(this.config.from).replace(/^whatsapp:/i, '')
    },
    esFuenteSandbox() {
      return this.fuenteChats === 'sandbox'
    },
    etiquetaBotonLimpiar() {
      if (this.modoLimpiar === 'fase3') return 'Borrar Fase 3'
      if (this.modoLimpiar === 'fase2') return 'Borrar Fase 2'
      return 'Borrar todo'
    },
    chipControlTexto() {
      const c = (this.controlEstado && this.controlEstado.control_conversacion) || 'ia'
      if (c === 'humano') return 'Control: tú'
      if (c === 'pausado') return 'Control: pausado'
      if (c === 'cerrado') return 'Control: cerrado'
      if (c === 'bot_perfilamiento') return 'Control: bot'
      return 'Control: IA'
    },
    chipControlColor() {
      const c = (this.controlEstado && this.controlEstado.control_conversacion) || 'ia'
      if (c === 'humano') return 'orange lighten-4'
      if (c === 'pausado' || c === 'cerrado') return 'grey lighten-3'
      return 'teal lighten-4'
    },
    iaBloqueadaPorHumano() {
      const e = this.controlEstado
      if (!e) return false
      return !!(e.humano_tomo_control || e.control_conversacion === 'humano' || e.ia_puede_responder === false)
    },
    esModoAuxiliar() {
      return this.modoOperacionAgente === 'auxiliar_humano'
    },
    esModoPausado() {
      return this.modoOperacionAgente === 'pausado'
    },
    puedeAutoEnviarIa() {
      return !!this.autoEnviarIaWhatsApp && !this.esModoAuxiliar && !this.esModoPausado
    },
    chipModoTexto() {
      if (this.esModoAuxiliar) return 'Modo: auxiliar'
      if (this.esModoPausado) return 'Modo: pausado'
      return 'Modo: autónomo'
    },
    chipModoColor() {
      if (this.esModoAuxiliar) return 'blue lighten-4'
      if (this.esModoPausado) return 'grey lighten-2'
      return 'teal lighten-4'
    },
    chipModoTextoCorto() {
      if (this.esModoAuxiliar) return 'aux'
      if (this.esModoPausado) return 'pause'
      return 'auto'
    },
    etiquetaAgenteBarra() {
      const id = this.idAgenteSeleccionado
      if (!id) return this.marcaPrompt || 'sin agente'
      const ag = (this.agentesLista || []).find((a) => a.id_agente === id)
      const nombre = (ag && (ag.nombre_publico || ag.id_agente)) || id
      const ver = this.versionAgenteSeleccionada
      return ver != null && ver !== '' ? `${nombre} · v${ver}` : String(nombre)
    },
    idConversacionActiva() {
      if (!this.chatActivo || !this.chatActivo.peer) return null
      const digits = String(this.chatActivo.peer).replace(/\D/g, '')
      return digits ? `CONV-${digits.slice(-10)}` : null
    },
    agentesSelectItems() {
      return (this.agentesLista || []).map((a) => ({
        text: `${a.nombre_publico || a.id_agente} (${a.id_agente})`,
        value: a.id_agente,
      }))
    },
    versionesAgenteItems() {
      return (this.versionesAgenteActivo || [])
        .filter((v) => v.estado_version === 'publicado' || v.estado_version === 'borrador')
        .map((v) => ({
          text: `v${v.numero_version} · ${v.estado_version}`,
          value: String(v.numero_version),
        }))
    },
    mostrarBotonTomarControl() {
      return !!this.chatActivo && !this.iaBloqueadaPorHumano
    },
    mostrarBotonDevolverIa() {
      return !!this.chatActivo && this.iaBloqueadaPorHumano
    },
    emptyChatsTexto() {
      if (this.fuenteChats === 'sandbox') {
        return 'Sin chats. Crea uno con + o únete al sandbox WhatsApp y actualiza.'
      }
      if (this.fuenteChats === 'fast') {
        return 'Sin chats FAST recientes. Prueba otra fuente o amplía el límite.'
      }
      return 'Sin chats INBI recientes. Cambia ciudad o pulsa actualizar.'
    },
    placeholderEnvio() {
      if (this.rolEnvio === 'asesor_local') return 'Solo se ve en pantalla (no WhatsApp)...'
      return 'Se envía a tu WhatsApp por el Sandbox...'
    },
    chatsFiltrados() {
      const q = String(this.buscar || '').trim().toLowerCase()
      if (!q) return this.chats
      return this.chats.filter((c) => {
        const tel = String(c.telefono || '').toLowerCase()
        const label = String(c.label || '').toLowerCase()
        return tel.includes(q) || label.includes(q)
      })
    },
    mensajesContexto() {
      const conv = this.contextoActivo && this.contextoActivo.conversacion
      return (conv && conv.mensajes) || []
    },
    leadResumen() {
      const lead = (this.contextoActivo && this.contextoActivo.lead) || {}
      return JSON.stringify({
        nombre: lead.nombre_completo,
        folio: lead.folio,
        telefono: lead.telefono,
        sucursal_interes: lead.sucursal_interes,
        curso_interes: lead.curso_interes,
        horario_interes: lead.horario_interes,
        idetapa: lead.idetapa,
        idprospectos: lead.idprospectos,
      }, null, 2)
    },
    perfilResumen() {
      const perfil = (this.contextoActivo && this.contextoActivo.perfil)
        || this.perfilActivo
        || null
      return JSON.stringify(perfil || { nota: 'Sin perfil aún — genera una Respuesta IA' }, null, 2)
    },
    /** Contrato congelado que ve la IA (Hito 1). */
    jsonContextoIa() {
      const ctx = this.contextoActivo && this.contextoActivo.contexto_ia
      return ctx && typeof ctx === 'object' ? ctx : null
    },
    contextoIaResumen() {
      if (!this.jsonContextoIa) {
        return JSON.stringify({
          nota: 'Sin contexto_ia. Pulsa Contexto (¿API actualizada con Hito 1?).',
        }, null, 2)
      }
      return JSON.stringify(this.jsonContextoIa, null, 2)
    },
    payloadIaBase() {
      if (!this.chatActivo) return null
      const esSandbox = this.fuenteChats === 'sandbox'
        || this.chatActivo.fuente === 'sandbox'
      const base = {
        fuente: esSandbox ? 'sandbox' : 'produccion',
        peer: this.chatActivo.peer,
        usuario: this.chatActivo.peer,
        twilio: this.chatActivo.twilio || null,
        marcaPrompt: this.marcaPromptParaChat(),
      }
      if (this.idAgenteSeleccionado) {
        base.id_agente = this.idAgenteSeleccionado
      }
      if (this.versionAgenteSeleccionada != null && this.versionAgenteSeleccionada !== '') {
        base.version_agente = this.versionAgenteSeleccionada
      }
      return base
    },
  },

  watch: {
    marcaPrompt() {
      if (this.chatActivo) this.cargarContextoIa(true)
    },
  },

  mounted() {
    this.inicializar()
    this.pollTimer = setInterval(() => {
      if (!this.esFuenteSandbox) return
      // Poll ligero: nunca esperar Auto-IA (eso va en background).
      if (this.chatActivo) {
        this.refrescarMensajes(true).catch(() => {})
      } else {
        this.cargarChats(true, { sinSyncTwilio: true }).catch(() => {})
      }
    }, 4000)
  },

  beforeDestroy() {
    if (this.pollTimer) clearInterval(this.pollTimer)
  },

  methods: {
    avisoSandbox(payload = {}) {
      const mensaje = payload.text || payload.mensaje || ''
      const tipo = payload.color || payload.tipo || 'info'
      this.$store.commit('mostrarAlerta', { mensaje, tipo })
    },
    async copiarTextoPortapapeles(texto) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(texto)
        return
      }
      const ta = document.createElement('textarea')
      ta.value = texto
      ta.setAttribute('readonly', '')
      ta.style.position = 'absolute'
      ta.style.left = '-9999px'
      document.body.appendChild(ta)
      ta.select()
      document.execCommand('copy')
      document.body.removeChild(ta)
    },
    irComercial() {
      if (this.$route.name === 'vendedorIaComercial') return
      this.$router.push({ name: 'vendedorIaComercial' }).catch(() => {})
    },

    irAgentes() {
      if (this.$route.name === 'vendedorIaAgentes') return
      this.$router.push({ name: 'vendedorIaAgentes' }).catch(() => {})
    },

    chatKey(chat) {
      if (!chat) return ''
      return `${chat.fuente || ''}|${chat.twilio || ''}|${chat.peer || ''}`
    },

    marcaPromptParaChat() {
      // chat.label de sandbox es "SANDBOX" (no es un prompt válido)
      const label = this.chatActivo && this.chatActivo.label
        ? String(this.chatActivo.label).toUpperCase()
        : ''
      if (label && this.marcasPrompt.includes(label)) return label
      if (this.fuenteChats === 'fast') return 'FAST'
      if (this.marcasPrompt.includes(this.marcaPrompt)) return this.marcaPrompt
      return 'INBI_MTY'
    },

    onCambioFuente() {
      this.chatActivo = null
      this.mensajes = []
      this.contextoActivo = null
      this.borradorActivo = null
      this.borradores = []
      this.syncAviso = null
      if (this.fuenteChats === 'fast') this.marcaPrompt = 'FAST'
      else if (this.fuenteChats === 'inbi' && this.filtroMarcaInbi !== 'TODAS') {
        this.marcaPrompt = this.filtroMarcaInbi
      } else if (this.fuenteChats === 'inbi') {
        this.marcaPrompt = 'INBI_MTY'
      }
      this.cargarChats()
    },

    async inicializar() {
      this.cargarLabConfig()
      await this.cargarConfig()
      await this.cargarListaAgentes()
      await this.cargarChats()
    },

    cargarLabConfig() {
      try {
        const raw = localStorage.getItem('via_sandbox_lab_config')
        if (!raw) return
        const cfg = JSON.parse(raw)
        if (cfg.delayAutoIaSegundos != null) this.delayAutoIaSegundos = Number(cfg.delayAutoIaSegundos) || 0
        if (cfg.delaySeguimientoMinutos != null) {
          this.delaySeguimientoMinutos = Number(cfg.delaySeguimientoMinutos)
        }
      } catch (_) { /* noop */ }
    },

    persistirLabConfig() {
      try {
        localStorage.setItem('via_sandbox_lab_config', JSON.stringify({
          delayAutoIaSegundos: this.delayAutoIaSegundos,
          delaySeguimientoMinutos: this.delaySeguimientoMinutos,
        }))
      } catch (_) { /* noop */ }
    },

    async cargarListaAgentes() {
      try {
        const res = await this.$http.get('vendedor-ia.agentes', { params: { solo_activos: '1' } })
        this.agentesLista = (res.data && res.data.agentes) || (res.body && res.body.agentes) || []
        const preferido = this.agentesLista.find((a) => a.id_agente === 'INBI_ASESORA_ANA')
          || this.agentesLista.find((a) => a.version_publicada)
          || this.agentesLista[0]
        if (preferido && !this.idAgenteSeleccionado) {
          this.idAgenteSeleccionado = preferido.id_agente
          await this.cargarVersionesAgenteSeleccionado()
        }
      } catch (_) {
        this.agentesLista = []
      }
    },

    async cargarVersionesAgenteSeleccionado() {
      this.versionesAgenteActivo = []
      if (!this.idAgenteSeleccionado) return
      try {
        const res = await this.$http.get(`vendedor-ia.agentes/${this.idAgenteSeleccionado}/versiones`)
        this.versionesAgenteActivo = (res.data && res.data.versiones) || []
        const pub = this.versionesAgenteActivo.find((v) => v.estado_version === 'publicado')
        if (pub) this.versionAgenteSeleccionada = String(pub.numero_version)
        else if (this.versionesAgenteActivo[0]) {
          this.versionAgenteSeleccionada = String(this.versionesAgenteActivo[0].numero_version)
        }
      } catch (_) {
        this.versionesAgenteActivo = []
      }
    },

    async onCambioAgenteSandbox() {
      await this.fijarAgenteEnConversacionActiva()
      await this.cargarModoOperacionAgente()
    },

    async onCambioIdAgenteSandbox() {
      if (this.idAgenteSeleccionado) {
        await this.cargarVersionesAgenteSeleccionado()
      } else {
        this.versionesAgenteActivo = []
        this.versionAgenteSeleccionada = null
      }
      await this.onCambioAgenteSandbox()
    },

    async fijarAgenteEnConversacionActiva() {
      const idConv = this.idConversacionActiva
      if (!idConv || !this.idAgenteSeleccionado) return
      try {
        const body = {
          id_agente: this.idAgenteSeleccionado,
          forzar: true,
        }
        if (this.versionAgenteSeleccionada != null && this.versionAgenteSeleccionada !== '') {
          body.version_agente = this.versionAgenteSeleccionada
        }
        const res = await this.$http.post(
          `vendedor-ia.agentes.conversacion/${idConv}/fijar`,
          body,
        )
        const payload = res.body || res.data || {}
        if (payload.modo_operacion) this.modoOperacionAgente = payload.modo_operacion
        if (payload.version_agente != null) {
          this.versionAgenteSeleccionada = String(payload.version_agente)
        }
      } catch (_) { /* conversación aún no existe en BD o flag OFF */ }
    },

    async enviarFrasePruebaLab(p) {
      const texto = p && p.texto ? String(p.texto).trim() : ''
      if (!texto) return
      if (!this.chatActivo || !this.esFuenteSandbox) {
        this.avisoSandbox({
          text: 'Abre un chat del Sandbox para probar',
          color: 'warning',
        })
        return
      }
      this.labEnviandoPrueba = true
      try {
        await this.$http.post('twilio-sandbox.simular-lead', {
          peer: this.chatActivo.peer,
          usuario: this.chatActivo.peer,
          body: texto,
          mensaje: texto,
        })
        // No disparar Auto-IA del poll; la lanzamos nosotros (más fiable con chips).
        await this.refrescarMensajes(true, { skipAutoIa: true })
        const inbounds = (this.mensajes || []).filter((m) => !Number(m.mio))
        const lastIn = inbounds.length ? inbounds[inbounds.length - 1] : null
        if (lastIn) {
          this.ultimoInboundId = this.claveInbound(lastIn)
          this.ultimoInboundTexto = String(lastIn.mensaje || '').trim()
          this.marcarInboundProcesado(lastIn)
        }
        this.avisoSandbox({
          text: `Lead simulado: ${p.titulo || 'prueba'}`,
          color: 'success',
        })
        if (
          this.autoGenerarIa
          && !this.iaBloqueadaPorHumano
          && !this.esModoPausado
          && !this.generandoBorrador
        ) {
          this.panelIaMinimizado = false
          this.tabIa = 1
          await this.generarBorradorIa({ desdeAuto: true })
        }
      } catch (e) {
        this.textoEnviar = texto
        const msg = (e.body && e.body.message)
          || (e.response && e.response.data && e.response.data.message)
          || e.message
        this.avisoSandbox({
          text: msg || 'No se pudo simular el mensaje del lead',
          color: 'error',
        })
      } finally {
        this.labEnviandoPrueba = false
      }
    },

    async cargarSeguimientosLab() {
      const idConv = this.idConversacionActiva
      if (!idConv) return
      this.labCargando = true
      try {
        const res = await this.$http.get('vendedor-ia.seguimientos', {
          params: { id_conversacion: idConv, limit: 30 },
        })
        const rows = (res.data && res.data.seguimientos) || []
        this.labSeguimientosTexto = JSON.stringify(rows, null, 2)
      } catch (e) {
        const msg = (e.response && e.response.data && e.response.data.message) || e.message
        this.avisoSandbox( { text: msg || 'No se listaron seguimientos', color: 'error' })
      } finally {
        this.labCargando = false
      }
    },

    async programarSeguimientoLab() {
      const idConv = this.idConversacionActiva
      if (!idConv) return
      this.labCargando = true
      try {
        const res = await this.$http.post('vendedor-ia.seguimientos.programar', {
          id_conversacion: idConv,
          tipo_seguimiento: 'sin_respuesta',
          marca: 'inbi',
          region: 'mty',
          delay_minutos_override: Number(this.delaySeguimientoMinutos),
          forzar: true,
        })
        const payload = res.data || res.body || {}
        this.avisoSandbox( {
          text: payload.message || (payload.ok ? 'Seguimiento programado' : 'No programado'),
          color: payload.ok ? 'success' : 'warning',
        })
        await this.cargarSeguimientosLab()
      } catch (e) {
        const msg = (e.response && e.response.data && e.response.data.message) || e.message
        this.avisoSandbox( { text: msg || 'Error al programar', color: 'error' })
      } finally {
        this.labCargando = false
      }
    },

    async simularTiempoPaso() {
      const idConv = this.idConversacionActiva
      if (!idConv) return
      this.labSimulando = true
      try {
        const res = await this.$http.post('vendedor-ia.seguimientos.simular-tiempo', {
          id_conversacion: idConv,
          minutos_adelante: 99999,
          ejecutar_worker: true,
        })
        const payload = res.data || res.body || {}
        this.avisoSandbox( {
          text: payload.message || 'Tiempo simulado',
          color: payload.ok ? 'success' : 'warning',
        })
        await this.cargarSeguimientosLab()
        if (this.esFuenteSandbox) await this.refrescarMensajes(true)
      } catch (e) {
        const msg = (e.response && e.response.data && e.response.data.message) || e.message
        this.avisoSandbox( { text: msg || 'Error al simular tiempo', color: 'error' })
      } finally {
        this.labSimulando = false
      }
    },

    construirMarkdownEcosistema(exp) {
      const ag = exp.agente && exp.agente.agente
      const preview = exp.agente && exp.agente.preview
      const msgs = (exp.contexto && exp.contexto.conversacion && exp.contexto.conversacion.mensajes) || []
      const lines = []
      lines.push('# Export ecosistema Vendedor IA (sandbox)')
      lines.push('')
      lines.push(`- Generado: ${exp.generado_en}`)
      lines.push(`- Entorno: ${exp.entorno}`)
      lines.push(`- Peer: ${exp.peer}`)
      lines.push(`- Conversación: ${exp.id_conversacion || '—'}`)
      lines.push(`- Fuente: ${exp.fuente}`)
      lines.push('')
      lines.push('## Flags')
      lines.push('```json')
      lines.push(JSON.stringify(exp.flags || {}, null, 2))
      lines.push('```')
      lines.push('')
      lines.push('## Agente / vendedora')
      lines.push('```json')
      lines.push(JSON.stringify({
        id_agente: ag && ag.id_agente,
        nombre_publico: ag && ag.nombre_publico,
        cargo: ag && ag.cargo,
        estado_agente: ag && ag.estado_agente,
        numero_version: exp.agente && exp.agente.numero_version,
        modo_operacion: preview && preview.modo_operacion,
      }, null, 2))
      lines.push('```')
      lines.push('')
      lines.push('## Prompt compilado')
      if (preview && preview.prompt_compilado) {
        lines.push(`Tokens aprox: ${preview.tokens_estimados || '—'}`)
        lines.push(`Bloques vacíos: ${(preview.bloques_vacios || []).join(', ') || 'ninguno'}`)
        lines.push('')
        lines.push('```markdown')
        lines.push(preview.prompt_compilado)
        lines.push('```')
      } else {
        lines.push('_Sin prompt compilado (revisa flags / versión)._')
      }
      lines.push('')
      lines.push('## Contexto IA (JSON)')
      lines.push('```json')
      lines.push(JSON.stringify((exp.contexto && exp.contexto.contexto_ia) || exp.contexto || {}, null, 2))
      lines.push('```')
      lines.push('')
      lines.push('## Chat (mensajes)')
      msgs.forEach((m, i) => {
        lines.push(`### ${i + 1}. ${m.rol || (m.mio ? 'asesor' : 'lead')} · ${m.fecha_creacion || ''}`)
        lines.push('')
        lines.push(String(m.mensaje || ''))
        lines.push('')
      })
      lines.push('## Seguimientos')
      lines.push('```json')
      lines.push(JSON.stringify(exp.seguimientos || [], null, 2))
      lines.push('```')
      lines.push('')
      lines.push('## Pedido a la IA (plantilla)')
      lines.push('Revisa este export y propone mejoras a comportamiento, comercial, objeciones y ejemplos del agente, sin violar el núcleo ni inventar precios/CLABE.')
      return lines.join('\n')
    },

    async descargarEcosistemaMd() {
      if (!this.chatActivo || !this.payloadIaBase) return
      this.labExportando = true
      try {
        const res = await this.$http.post('vendedor-ia.sandbox.export-ecosistema', {
          ...this.payloadIaBase,
          id_agente: this.idAgenteSeleccionado,
          version_agente: this.versionAgenteSeleccionada,
          limit: 80,
        })
        const payload = res.data || res.body || {}
        const exp = payload.export || payload
        const md = this.construirMarkdownEcosistema(exp)
        const blob = new Blob([md], { type: 'text/markdown;charset=utf-8' })
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        const stamp = new Date().toISOString().replace(/[:.]/g, '-')
        a.href = url
        a.download = `via-ecosistema-${this.idConversacionActiva || 'chat'}-${stamp}.md`
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        URL.revokeObjectURL(url)
        this.avisoSandbox( { text: 'Markdown descargado', color: 'success' })
      } catch (e) {
        const msg = (e.response && e.response.data && e.response.data.message) || e.message
        this.avisoSandbox( { text: msg || 'Error al exportar', color: 'error' })
      } finally {
        this.labExportando = false
      }
    },

    nombreArchivoConversacionJson() {
      const peer = this.chatActivo && (this.chatActivo.peer || this.chatActivo.telefono)
        ? String(this.chatActivo.peer || this.chatActivo.telefono).replace(/[^\dA-Za-z_-]+/g, '-')
        : 'chat'
      const stamp = new Date().toISOString().replace(/[:.]/g, '-')
      return `conversacion-${peer}-${stamp}.json`
    },

    async construirJsonConversacion() {
      if (!this.chatActivo) return null
      if (this.esFuenteSandbox) {
        try {
          await this.$http.post('twilio-sandbox.sincronizar', { limit: 200 })
          this.ultimoSyncTwilioMs = Date.now()
        } catch (_) { /* exportar lo guardado localmente */ }
      }
      const res = await this.$http.post('vendedor-ia.mensajes', {
        fuente: this.chatActivo.fuente || this.fuenteChats,
        peer: this.chatActivo.peer,
        usuario: this.chatActivo.peer,
        twilio: this.chatActivo.twilio,
        bdName: this.chatActivo.bdName,
        limit: 1000,
      })
      const payload = res.body || res.data || {}
      const mensajes = payload.mensajes || (Array.isArray(payload) ? payload : [])
      return {
        generado_en: new Date().toISOString(),
        fuente: this.chatActivo.fuente || this.fuenteChats,
        chat: { ...this.chatActivo },
        total_mensajes: Array.isArray(mensajes) ? mensajes.length : 0,
        mensajes: Array.isArray(mensajes) ? mensajes : [],
      }
    },

    async copiarConversacionJson() {
      if (!this.chatActivo) return
      this.exportandoJsonConversacion = 'copiar'
      try {
        const data = await this.construirJsonConversacion()
        await this.copiarTextoPortapapeles(JSON.stringify(data, null, 2))
        this.avisoSandbox({ text: 'Conversación JSON copiada', color: 'success' })
      } catch (e) {
        const msg = (e.response && e.response.data && e.response.data.message) || e.message
        this.avisoSandbox({ text: msg || 'No se pudo copiar la conversación', color: 'error' })
      } finally {
        this.exportandoJsonConversacion = null
      }
    },

    async descargarConversacionJson() {
      if (!this.chatActivo) return
      this.exportandoJsonConversacion = 'descargar'
      try {
        const data = await this.construirJsonConversacion()
        const json = JSON.stringify(data, null, 2)
        const blob = new Blob([json], { type: 'application/json;charset=utf-8' })
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = this.nombreArchivoConversacionJson()
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        URL.revokeObjectURL(url)
        this.avisoSandbox({ text: 'Conversación JSON descargada', color: 'success' })
      } catch (e) {
        const msg = (e.response && e.response.data && e.response.data.message) || e.message
        this.avisoSandbox({ text: msg || 'No se pudo descargar la conversación', color: 'error' })
      } finally {
        this.exportandoJsonConversacion = null
      }
    },

    async cargarConfig() {
      try {
        const res = await this.$http.get('twilio-sandbox.config')
        this.config = res.body || res.data || null
      } catch (e) {
        this.config = { enabled: false, joinCode: '', from: 'whatsapp:+14155238886' }
      }
    },

    async cargarChats(silent = false, opts = {}) {
      if (!silent) this.cargandoChats = true
      try {
        // En sandbox, sync desde Twilio solo en carga manual / no silenciosa
        if (this.fuenteChats === 'sandbox' && !opts.sinSyncTwilio) {
          try {
            await this.$http.get('twilio-sandbox.chats')
          } catch (_) { /* seguir con listado local */ }
        }

        const body = {
          fuente: this.fuenteChats,
          limit: 400,
          dias: 30,
        }
        if (this.fuenteChats === 'inbi' && this.filtroMarcaInbi && this.filtroMarcaInbi !== 'TODAS') {
          body.marcaPrompt = this.filtroMarcaInbi
        }
        const res = await this.$http.post('vendedor-ia.chats', body)
        const payload = res.body || res.data || {}
        this.chats = payload.chats || []
        this.syncAviso = payload.nota
          ? { tipo: 'info', texto: payload.nota }
          : null
      } catch (e) {
        if (!silent) {
          const msg = (e.body && e.body.message)
            || (e.response && e.response.data && e.response.data.message)
            || 'No se pudieron cargar los chats'
          this.avisoSandbox( { text: msg, color: 'error' })
        }
      } finally {
        if (!silent) this.cargandoChats = false
      }
    },

    abrirChat(chat) {
      this.chatActivo = chat
      this.borradorActivo = null
      this.borradores = []
      this.contextoActivo = null
      this.perfilActivo = null
      this.controlEstado = null
      this.modoOperacionAgente = 'autonomo_sandbox'
      this.ultimoInboundId = null
      this.ultimoInboundTexto = null
      this.iaAutoLock = false
      this.inboundPendienteAutoIa = false
      this.inboundIaProcesados = {}
      this.inboundIaIntentos = {}
      this.tabIa = 0
      const label = chat && chat.label ? String(chat.label).toUpperCase() : ''
      if (label && this.marcasPrompt.includes(label)) {
        this.marcaPrompt = label
      } else if (this.fuenteChats === 'fast') {
        this.marcaPrompt = 'FAST'
      } else if (!this.marcasPrompt.includes(this.marcaPrompt)) {
        this.marcaPrompt = 'INBI_MTY'
      }
      this.refrescarMensajes()
      this.cargarBorradores()
      this.cargarContextoIa(true)
      this.cargarControlEstado(true)
      this.cargarModoOperacionAgente()
    },

    async cargarModoOperacionAgente() {
      const idConv = this.idConversacionActiva
      if (!idConv) return
      try {
        const res = await this.$http.get(`vendedor-ia.agentes.conversacion/${idConv}/modo`)
        const payload = res.body || res.data || {}
        if (payload.modo_operacion) {
          this.modoOperacionAgente = payload.modo_operacion
          if (this.esModoAuxiliar || this.esModoPausado) {
            this.autoEnviarIaWhatsApp = false
          }
        }
        if (payload.id_agente) {
          this.idAgenteSeleccionado = payload.id_agente
          await this.cargarVersionesAgenteSeleccionado()
        }
        if (payload.version_agente != null) {
          this.versionAgenteSeleccionada = String(payload.version_agente)
        }
      } catch (_) {
        /* flag/admin/agente no listo: default autónomo */
      }
    },

    /** Media incompleta: no disparar Auto-IA todavía */
    esTextoMediaPendiente(texto) {
      const t = String(texto || '').trim()
      if (!t) return true
      return t === '[Audio recibido]'
        || t.startsWith('[Audio recibido; no se pudo transcribir]')
        || t.startsWith('[Audio recibido')
        || t === '[Imagen recibida]'
        || t.startsWith('[Imagen recibida; no se pudo analizar]')
        || t.startsWith('[Imagen recibida')
        || t.startsWith('[Media recibida; se omitió')
        || t === '[Mensaje recibido sin texto]'
    },

    /** Compat: alias del nombre anterior */
    esTextoAudioPendiente(texto) {
      return this.esTextoMediaPendiente(texto)
    },

    /** Solo mensajes recientes (webhooks atrasados no deben auto-responder) */
    esInboundReciente(m, maxMs = 3 * 60 * 1000) {
      if (!m || !m.fecha_creacion) return false
      const d = new Date(m.fecha_creacion)
      if (Number.isNaN(d.getTime())) return false
      return Date.now() - d.getTime() <= maxMs
    },

    claveInbound(m) {
      if (!m) return null
      if (m.id != null && m.id !== '') return `id:${m.id}`
      const fecha = m.fecha_creacion || ''
      const texto = String(m.mensaje || '').slice(0, 120)
      return `f:${fecha}|${texto}`
    },

    huellaInbound(m) {
      if (!m) return null
      const fecha = m.fecha_creacion || ''
      const texto = String(m.mensaje || '').slice(0, 120)
      return `f:${fecha}|${texto}`
    },

    yaProcesadoInbound(m) {
      const idKey = this.claveInbound(m)
      const finger = this.huellaInbound(m)
      return !!(
        (idKey && this.inboundIaProcesados[idKey])
        || (finger && this.inboundIaProcesados[finger])
      )
    },

    intentosInbound(m) {
      const idKey = this.claveInbound(m)
      if (!idKey) return 0
      return Number(this.inboundIaIntentos[idKey]) || 0
    },

    registrarIntentoInbound(m) {
      const idKey = this.claveInbound(m)
      if (!idKey) return 0
      const n = (Number(this.inboundIaIntentos[idKey]) || 0) + 1
      this.inboundIaIntentos = { ...this.inboundIaIntentos, [idKey]: n }
      return n
    },

    marcarInboundProcesado(m) {
      const idKey = this.claveInbound(m)
      const finger = this.huellaInbound(m)
      const next = { ...this.inboundIaProcesados }
      if (idKey) next[idKey] = true
      if (finger) next[finger] = true
      this.inboundIaProcesados = next
    },

    /**
     * Si el lead respondió mientras generábamos el turno anterior, dispara Auto-IA
     * sin esperar a que el poll vea un “cambio” de ultimoInboundId.
     */
    intentarAutoIaInboundPendiente() {
      if (!this.inboundPendienteAutoIa) return
      if (!this.esFuenteSandbox || !this.autoGenerarIa) return
      if (this.iaAutoLock || this.generandoBorrador) return
      if (this.iaBloqueadaPorHumano || this.esModoPausado) return
      this.refrescarMensajes(true)
    },

    async refrescarMensajes(silent = false, opts = {}) {
      if (!this.chatActivo) return
      // Evita saturar el browser/API mientras Auto-IA tarda (OpenAI/Twilio).
      if (this.refrescoMensajesEnCurso) return
      const skipAutoIa = !!(opts && opts.skipAutoIa)
      this.refrescoMensajesEnCurso = true
      if (!silent) this.cargandoMensajes = true
      try {
        // Si el webhook/ngrok falla, igual recuperamos mensajes desde Twilio.
        const forzarSync = !!(opts && opts.syncTwilio) || !silent
        const staleSync = !this.ultimoSyncTwilioMs || (Date.now() - this.ultimoSyncTwilioMs > 12000)
        if (this.esFuenteSandbox && (forzarSync || staleSync)) {
          try {
            await this.$http.post('twilio-sandbox.sincronizar', { limit: 80 })
            this.ultimoSyncTwilioMs = Date.now()
          } catch (_) { /* seguir con BD local */ }
        }
        const res = await this.$http.post('vendedor-ia.mensajes', {
          fuente: this.chatActivo.fuente || this.fuenteChats,
          peer: this.chatActivo.peer,
          usuario: this.chatActivo.peer,
          twilio: this.chatActivo.twilio,
          bdName: this.chatActivo.bdName,
          limit: 200,
        })
        const payload = res.body || res.data || {}
        const nuevos = payload.mensajes || (Array.isArray(payload) ? payload : [])
        const prevInboundId = this.ultimoInboundId
        const prevInboundTexto = this.ultimoInboundTexto
        this.mensajes = Array.isArray(nuevos) ? nuevos.slice() : []
        this.scrollMensajesAlFinal()

        // Auto-IA cuando llega un mensaje nuevo del celular (lead = mio 0)
        const inbounds = this.mensajes.filter((m) => !Number(m.mio))
        const lastIn = inbounds.length ? inbounds[inbounds.length - 1] : null
        const lastInId = this.claveInbound(lastIn)
        const lastInTexto = lastIn ? String(lastIn.mensaje || '').trim() : ''
        if (lastInId) this.ultimoInboundId = lastInId
        this.ultimoInboundTexto = lastInTexto

        // Whisper/Vision: mismo mensaje pasa de placeholder → texto útil
        const transcripcionLista = !!(
          lastInId
          && prevInboundId
          && lastInId === prevInboundId
          && this.esTextoMediaPendiente(prevInboundTexto)
          && lastInTexto
          && !this.esTextoMediaPendiente(lastInTexto)
        )

        const intentos = this.intentosInbound(lastIn)
        if (intentos >= 2) {
          this.marcarInboundProcesado(lastIn)
        }

        const inboundListoParaIa = !!(
          lastInId
          && !this.yaProcesadoInbound(lastIn)
          && !this.esTextoMediaPendiente(lastInTexto)
          && this.esInboundReciente(lastIn)
          && intentos < 2
        )
        const esNuevoInbound = !!(
          inboundListoParaIa
          && prevInboundId
          && lastInId !== prevInboundId
        ) || (
          // Mismo id ya “visto” en un poll con lock / skipAutoIa, aún sin respuesta IA
          inboundListoParaIa
          && this.inboundPendienteAutoIa
        ) || (
          transcripcionLista
          && !this.yaProcesadoInbound(lastIn)
          && this.esInboundReciente(lastIn)
          && intentos < 2
        )

        // Tras generar+enviar, el refresh skipAutoIa puede traer ya el siguiente
        // mensaje del lead (p.ej. “En línea”) sin disparar Auto-IA.
        if (
          skipAutoIa
          && inboundListoParaIa
          && this.esFuenteSandbox
          && this.autoGenerarIa
          && !this.iaBloqueadaPorHumano
          && !this.esModoPausado
        ) {
          this.inboundPendienteAutoIa = true
        }

        // Inbound llegó mientras Auto-IA estaba ocupada: no lo marcamos procesado,
        // pero el poll ya actualizó ultimoInboundId → sin flag, el siguiente ciclo
        // no lo ve como "nuevo" y se traga respuestas cortas (p.ej. "En línea").
        if (
          !skipAutoIa
          && this.esFuenteSandbox
          && this.autoGenerarIa
          && esNuevoInbound
          && (this.iaAutoLock || this.generandoBorrador)
          && !this.iaBloqueadaPorHumano
          && !this.esModoPausado
        ) {
          this.inboundPendienteAutoIa = true
        }

        if (
          !skipAutoIa
          && this.esFuenteSandbox
          && this.autoGenerarIa
          && esNuevoInbound
          && !this.iaAutoLock
          && !this.generandoBorrador
          && !this.iaBloqueadaPorHumano
          && !this.esModoPausado
        ) {
          // NO await: si Auto-IA/OpenAI tarda, el poll debe seguir refrescando el chat.
          this.iaAutoLock = true
          this.inboundPendienteAutoIa = false
          const n = this.registrarIntentoInbound(lastIn)
          this.marcarInboundProcesado(lastIn)
          const inboundSnap = lastIn
          Promise.resolve()
            .then(async () => {
              const delayMs = Math.max(0, Number(this.delayAutoIaSegundos) || 0) * 1000
              if (delayMs > 0) {
                await new Promise((r) => setTimeout(r, delayMs))
              }
              const ok = await this.generarBorradorIa({ desdeAuto: true })
              if (!ok && n < 2) {
                const idKey = this.claveInbound(inboundSnap)
                const finger = this.huellaInbound(inboundSnap)
                const next = { ...this.inboundIaProcesados }
                if (idKey) delete next[idKey]
                if (finger) delete next[finger]
                this.inboundIaProcesados = next
              }
              // Mostrar respuesta enviada / borradores sin esperar el siguiente poll
              await this.refrescarMensajes(true, { skipAutoIa: true })
            })
            .catch(() => {})
            .finally(() => {
              this.iaAutoLock = false
              // Si llegó otro mensaje del lead mientras generábamos (o el sync
              // post-envío ya lo trae), procesarlo ya — no esperar un "cambio de id".
              this.$nextTick(() => {
                this.intentarAutoIaInboundPendiente()
              })
            })
        }
      } catch (e) {
        if (!silent) {
          const msg = (e.body && e.body.message)
            || (e.response && e.response.data && e.response.data.message)
            || e.message
            || 'No se pudieron cargar mensajes'
          this.avisoSandbox({ text: msg, color: 'error' })
        }
      } finally {
        this.refrescoMensajesEnCurso = false
        if (!silent) this.cargandoMensajes = false
      }
    },

    async cargarContextoIa(silent = false) {
      if (!this.chatActivo || !this.payloadIaBase) return
      if (!silent) this.cargandoContexto = true
      try {
        const res = await this.$http.post('vendedor-ia.contexto', this.payloadIaBase)
        this.contextoActivo = res.body || res.data || null
        this.perfilActivo = (this.contextoActivo && this.contextoActivo.perfil) || null
        this.sincronizarControlDesdePerfil(this.perfilActivo)
        this.tabIa = 0
        this.cargarControlEstado(true)
      } catch (e) {
        if (!silent) {
          const msg = (e.body && e.body.message)
            || (e.response && e.response.data && e.response.data.message)
            || 'No se pudo armar el contexto'
          this.avisoSandbox( { text: msg, color: 'error' })
        }
      } finally {
        if (!silent) this.cargandoContexto = false
      }
    },

    sincronizarControlDesdePerfil(perfil) {
      if (!perfil) return
      if (perfil.control_conversacion == null && perfil.humano_tomo_control == null) return
      this.controlEstado = {
        ...(this.controlEstado || {}),
        control_conversacion: perfil.control_conversacion || 'ia',
        ia_puede_responder: perfil.ia_puede_responder !== false,
        humano_tomo_control: !!perfil.humano_tomo_control,
        id_humano_control: perfil.id_humano_control || null,
        fuente: perfil.control_fuente || 'envelope',
      }
    },

    async cargarControlEstado(silent = false) {
      if (!this.chatActivo || !this.payloadIaBase) return
      if (!silent) this.cargandoControl = true
      try {
        const res = await this.$http.post('vendedor-ia.control.estado', this.payloadIaBase)
        const payload = res.body || res.data || {}
        if (payload.estado) this.controlEstado = payload.estado
      } catch (e) {
        if (!silent) {
          const msg = (e.body && e.body.message)
            || (e.response && e.response.data && e.response.data.message)
            || 'No se pudo leer el control'
          this.avisoSandbox( { text: msg, color: 'warning' })
        }
      } finally {
        if (!silent) this.cargandoControl = false
      }
    },

    async tomarControlConversacion() {
      if (!this.chatActivo || !this.payloadIaBase) return
      this.accionControl = true
      try {
        const res = await this.$http.post('vendedor-ia.control.tomar', {
          ...this.payloadIaBase,
          motivo: 'takeover_asesora_sandbox',
        })
        const payload = res.body || res.data || {}
        if (payload.estado) this.controlEstado = payload.estado
        if (payload.perfil) {
          this.perfilActivo = payload.perfil
          if (this.contextoActivo) {
            this.contextoActivo = { ...this.contextoActivo, perfil: payload.perfil }
          }
        }
        this.avisoSandbox( {
          text: payload.message || 'Tomaste el control. La IA no responderá.',
          color: 'success',
        })
      } catch (e) {
        const msg = (e.body && e.body.message)
          || (e.response && e.response.data && e.response.data.message)
          || 'No se pudo tomar el control'
        this.avisoSandbox( { text: msg, color: 'error' })
      } finally {
        this.accionControl = false
      }
    },

    async devolverControlIa() {
      if (!this.chatActivo || !this.payloadIaBase) return
      this.accionControl = true
      try {
        const res = await this.$http.post('vendedor-ia.control.devolver-ia', this.payloadIaBase)
        const payload = res.body || res.data || {}
        if (payload.estado) this.controlEstado = payload.estado
        if (payload.perfil) {
          this.perfilActivo = payload.perfil
          if (this.contextoActivo) {
            this.contextoActivo = { ...this.contextoActivo, perfil: payload.perfil }
          }
        }
        this.avisoSandbox( {
          text: payload.message || 'Control devuelto a la IA',
          color: 'success',
        })
      } catch (e) {
        const msg = (e.body && e.body.message)
          || (e.response && e.response.data && e.response.data.message)
          || 'No se pudo devolver el control'
        this.avisoSandbox( { text: msg, color: 'error' })
      } finally {
        this.accionControl = false
      }
    },

    async copiarContextoIaJson() {
      if (!this.jsonContextoIa) {
        this.avisoSandbox( {
          text: 'No hay contexto_ia. Pulsa Contexto primero.',
          color: 'warning',
        })
        return
      }
      const texto = JSON.stringify(this.jsonContextoIa, null, 2)
      try {
        await this.copiarTextoPortapapeles(texto)
        this.avisoSandbox( {
          text: 'contexto_ia copiado — pégalo en el chat para revisar la prueba',
          color: 'success',
        })
      } catch (e) {
        this.avisoSandbox( {
          text: 'No se pudo copiar al portapapeles',
          color: 'error',
        })
      }
    },

    async cargarBorradores() {
      if (!this.chatActivo) return
      try {
        const twilio = this.chatActivo.twilio
          || (this.config && this.config.from)
          || 'whatsapp:+14155238886'
        const res = await this.$http.get('vendedor-ia.borradores', {
          params: {
            twilio,
            usuario: this.chatActivo.peer,
            limit: 10,
          },
        })
        const payload = res.body || res.data || {}
        this.borradores = payload.borradores || []
        if (this.borradores.length && !this.borradorActivo) {
          this.borradorActivo = this.borradores[0]
        }
      } catch (e) {
        // silencioso
      }
    },

    seleccionarBorrador(b) {
      this.borradorActivo = b
      this.tabIa = 1
    },

    textoWhatsAppDesdeBorrador(borrador) {
      const raw = String(borrador || '').trim()
      if (!raw) return ''
      const match = raw.match(/RESPUESTA\s+PARA\s+WHATSAPP\s*:?\s*\r?\n([\s\S]*)$/i)
      if (match && match[1].trim()) return match[1].trim()
      const sameLine = raw.match(/RESPUESTA\s+PARA\s+WHATSAPP\s*:\s*(.+)$/i)
      if (sameLine && sameLine[1].trim()) return sameLine[1].trim()
      if (!/DATOS\s+DETECTADOS/i.test(raw)) return raw
      return ''
    },

    textoParaEnviarWhatsApp(borradorObj = this.borradorActivo) {
      if (!borradorObj) return ''
      const directo = String(borradorObj.borrador_whatsapp || '').trim()
      if (directo) return directo
      return this.textoWhatsAppDesdeBorrador(borradorObj.borrador || borradorObj.texto)
    },

    async generarBorradorIa(opts = {}) {
      const desdeAuto = !!(opts && opts.desdeAuto)
      if (!this.chatActivo || !this.payloadIaBase) return false
      if (this.generandoBorrador) return false
      if (this.esModoPausado) {
        if (!desdeAuto) {
          this.avisoSandbox( {
            text: 'Agente en modo pausado: no genera borradores.',
            color: 'warning',
          })
        }
        return false
      }
      if (this.iaBloqueadaPorHumano) {
        if (!desdeAuto) {
          this.avisoSandbox( {
            text: 'Tomaste el control: la IA no genera borradores hasta que la reactives.',
            color: 'warning',
          })
        }
        return false
      }
      this.generandoBorrador = true
      try {
        const res = await this.$http.post('vendedor-ia.borrador', {
          ...this.payloadIaBase,
          promptId: 'INBI_ETAPA_CALIFICACION_INICIAL',
          modoPrueba: true,
        })
        const payload = res.body || res.data || {}
        if (payload.modo_operacion) {
          this.modoOperacionAgente = payload.modo_operacion
          if (this.esModoAuxiliar || this.esModoPausado) {
            this.autoEnviarIaWhatsApp = false
          }
        }
        const borradorCompleto = payload.borrador || ''
        const wa = String(payload.borrador_whatsapp || '').trim()
          || this.textoWhatsAppDesdeBorrador(borradorCompleto)
          || (payload.duplicado ? '¿En qué puedo ayudarte?' : '')
          || (borradorCompleto ? '¿En qué puedo ayudarte?' : '')
        this.borradorActivo = {
          id: payload.id,
          borrador: borradorCompleto || wa,
          borrador_whatsapp: wa,
          adjuntos: Array.isArray(payload.adjuntos) ? payload.adjuntos : [],
          herramientas_ejecutadas: payload.herramientas_ejecutadas || [],
          prompt_version: payload.prompt_version,
          fecha_creacion: new Date().toISOString(),
          texto: borradorCompleto || wa,
        }
        if (payload.contexto) {
          this.contextoActivo = payload.contexto
        }
        if (payload.perfil) {
          this.perfilActivo = payload.perfil
          if (this.contextoActivo) {
            this.contextoActivo = { ...this.contextoActivo, perfil: payload.perfil }
          }
        }
        await this.cargarBorradores()
        this.tabIa = 1

        // H1-P06: turno ya respondido — no reenviar el mismo WhatsApp (parece que
        // “En línea” no avanzó cuando en realidad se reenvió el borrador del nombre).
        if (payload.duplicado) {
          if (!desdeAuto) {
            this.avisoSandbox({
              text: 'Turno ya procesado: no se reenvía el borrador duplicado.',
              color: 'info',
            })
          }
          return true
        }

        const textoWa = this.textoParaEnviarWhatsApp(this.borradorActivo)
        const adjuntos = (this.borradorActivo && this.borradorActivo.adjuntos) || []
        if (this.esFuenteSandbox && this.puedeAutoEnviarIa) {
          if (!textoWa && !(adjuntos && adjuntos.length)) {
            this.avisoSandbox( {
              text: 'IA generó datos pero sin mensaje WhatsApp. Pulsa "Respuesta IA" de nuevo.',
              color: 'warning',
            })
            return false
          }
          const enviado = await this.enviarTextoAWhatsAppSandbox(textoWa, {
            silencioso: !!desdeAuto,
            adjuntos,
          })
          return !!enviado
        }
        if (!desdeAuto) {
          const msgAux = this.esModoAuxiliar
            ? 'Sugerencia IA lista (modo auxiliar). Revisa y envía manualmente.'
            : 'Respuesta IA generada. Pulsa "Enviar a WhatsApp" para mandarla al celular.'
          this.avisoSandbox( {
            text: msgAux,
            color: 'success',
          })
        }
        return true
      } catch (e) {
        const body = (e.body) || (e.response && e.response.data) || {}
        const msg = body.message || 'No se pudo generar la respuesta IA'
        if (body.codigo === 'AGENTE_PAUSADO') {
          this.modoOperacionAgente = 'pausado'
          this.autoEnviarIaWhatsApp = false
        }
        if (body.bloqueado || body.codigo === 'HUMANO_ACTIVO' || body.transferido || e.status === 403 || e.status === 422) {
          if (body.estado_control) this.controlEstado = body.estado_control
          else this.cargarControlEstado(true)
        }
        this.avisoSandbox( { text: msg, color: 'error' })
        return false
      } finally {
        this.generandoBorrador = false
      }
    },

    /**
     * Envía texto real por Twilio Sandbox al peer del chat activo.
     * Opcional: adjuntos [{url}] (PDF métodos de pago, etc.) → mediaUrl Twilio.
     */
    async enviarTextoAWhatsAppSandbox(texto, { silencioso = false, adjuntos = [] } = {}) {
      let body = String(texto || '').trim()
      // WhatsApp no renderiza markdown: evita [url](url) duplicado en el chat
      body = body.replace(/\[([^\]]*)\]\((https?:\/\/[^)\s]+)\)/gi, (_, label, url) => {
        const lab = String(label || '').trim()
        const u = String(url || '').trim()
        if (!lab || lab === u || /^https?:\/\//i.test(lab)) return u
        return `${lab}\n${u}`
      }).trim()
      const mediaUrls = (Array.isArray(adjuntos) ? adjuntos : [])
        .map((a) => (a && (a.url || a.url_recurso || a.mediaUrl)) || null)
        .filter((u) => u && /^https?:\/\//i.test(String(u)))
      if ((!body && !mediaUrls.length) || !this.chatActivo) return false
      this.enviando = true
      try {
        const payload = {
          to: this.chatActivo.peer,
          body: body || (mediaUrls.length ? 'Te mando el documento oficial.' : ''),
          es_respuesta_ia: true,
          origen: 'ia_borrador',
        }
        if (mediaUrls.length) {
          payload.mediaUrls = mediaUrls
          payload.adjuntos = adjuntos
        }
        await this.$http.post('twilio-sandbox.enviar', payload)
        await this.refrescarMensajes(true)
        await this.cargarChats(true)
        if (!silencioso) {
          this.avisoSandbox( {
            text: mediaUrls.length
              ? 'Enviado a WhatsApp con archivo (Sandbox)'
              : 'Enviado a WhatsApp (Sandbox)',
            color: 'success',
          })
        }
        return true
      } catch (e) {
        const bodyErr = (e.body) || (e.response && e.response.data) || {}
        const msg = bodyErr.message
          || 'Error al enviar a WhatsApp'
        if (bodyErr.bloqueado || bodyErr.codigo) {
          if (bodyErr.transferido) this.cargarControlEstado(true)
        }
        this.avisoSandbox( { text: msg, color: 'error' })
        return false
      } finally {
        this.enviando = false
      }
    },

    async enviarBorradorAWhatsApp() {
      const texto = this.textoParaEnviarWhatsApp()
      const adjuntos = (this.borradorActivo && this.borradorActivo.adjuntos) || []
      if (!texto && !(adjuntos && adjuntos.length)) {
        this.avisoSandbox( {
          text: 'No hay mensaje WhatsApp en el borrador. Genera de nuevo la respuesta IA.',
          color: 'warning',
        })
        return
      }
      await this.enviarTextoAWhatsAppSandbox(texto, { adjuntos })
    },

    normalizarPeerLocal(tel) {
      const digits = String(tel || '').replace(/\D/g, '')
      if (!digits) return ''
      return `whatsapp:+${digits}`
    },

    crearChatPrueba() {
      const peer = this.normalizarPeerLocal(this.nuevoChatTelefono)
      if (!peer) {
        return this.avisoSandbox( { text: 'Teléfono inválido', color: 'warning' })
      }
      const telefono = peer.replace(/^whatsapp:/i, '')
      const from = (this.config && this.config.from) || 'whatsapp:+14155238886'
      const chat = {
        peer,
        telefono,
        preview: 'Chat de prueba (vacío)',
        ultimo_mensaje: new Date().toISOString(),
        twilio: from,
        bdName: String(from).replace(/\D/g, ''),
        marca: 'SANDBOX',
        label: 'SANDBOX',
        fuente: 'sandbox',
      }
      const existe = this.chats.find((c) => c.peer === peer)
      if (!existe) this.chats.unshift(chat)
      this.dialogNuevoChat = false
      this.nuevoChatTelefono = ''
      this.fuenteChats = 'sandbox'
      this.abrirChat(existe || chat)
    },

    confirmarLimpiarConversacion() {
      if (!this.chatActivo) return
      this.modoLimpiar = 'fase3'
      this.dialogLimpiar = true
    },

    async limpiarConversacion() {
      if (!this.chatActivo) return
      this.limpiandoChat = true
      const modo = ['fase2', 'fase3'].includes(this.modoLimpiar)
        ? this.modoLimpiar
        : 'todo'
      try {
        const resp = await this.$http.post('twilio-sandbox.limpiar', {
          peer: this.chatActivo.peer,
          modo,
        })
        const body = (resp && resp.body) || (resp && resp.data) || {}

        if (modo === 'fase2' || modo === 'fase3') {
          this.borradorActivo = null
          this.borradores = []
          this.contextoActivo = null
          this.inboundIaProcesados = {}
          this.inboundIaIntentos = {}
          this.inboundPendienteAutoIa = false
          this.dialogLimpiar = false
          await this.refrescarMensajes(true, { syncTwilio: false })
          await this.cargarContextoIa(true)
          const n = body.mensajes_eliminados != null ? body.mensajes_eliminados : 0
          const label = modo === 'fase3' ? 'Fase 3' : 'Fase 2'
          this.avisoSandbox({
            text: n > 0
              ? `${label} limpiada (${n} mensajes).`
              : `CTX ${label} limpio.`,
            color: 'success',
          })
        } else {
          this.mensajes = []
          this.borradorActivo = null
          this.borradores = []
          this.contextoActivo = null
          this.perfilActivo = null
          this.controlEstado = null
          this.ultimoInboundId = null
          this.ultimoInboundTexto = null
          this.iaAutoLock = false
          this.inboundPendienteAutoIa = false
          this.inboundIaProcesados = {}
          this.inboundIaIntentos = {}
          this.dialogLimpiar = false
          this.chatActivo.preview = 'Sin mensajes'
          await this.cargarChats(true)
          this.avisoSandbox({
            text: 'Conversación limpiada (no se restaurará al refrescar)',
            color: 'success',
          })
        }
      } catch (e) {
        const msg = (e.body && e.body.message)
          || (e.response && e.response.data && e.response.data.message)
          || 'No se pudo limpiar'
        this.avisoSandbox({ text: msg, color: 'error' })
      } finally {
        this.limpiandoChat = false
      }
    },

    async usarBorradorComoAsesor() {
      return this.enviarBorradorAWhatsApp()
    },

    async enviarMensaje() {
      if (!this.esFuenteSandbox) {
        return this.avisoSandbox( {
          text: 'Envío deshabilitado fuera de Sandbox',
          color: 'warning',
        })
      }
      if (!this.chatActivo || !this.textoEnviar.trim()) return
      const texto = this.textoEnviar.trim()

      if (this.rolEnvio === 'asesor_local') {
        this.enviando = true
        try {
          await this.$http.post('twilio-sandbox.simular-asesor', {
            peer: this.chatActivo.peer,
            body: texto,
          })
          this.textoEnviar = ''
          await this.refrescarMensajes(true)
          await this.cargarChats(true)
        } catch (e) {
          const msg = (e.body && e.body.message) || (e.response && e.response.data && e.response.data.message) || 'Error al enviar'
          this.avisoSandbox( { text: msg, color: 'error' })
        } finally {
          this.enviando = false
        }
        return
      }

      const ok = await this.enviarTextoAWhatsAppSandbox(texto)
      if (ok) this.textoEnviar = ''
    },

    async enviarPlantilla() {
      if (!this.esFuenteSandbox) {
        return this.avisoSandbox( {
          text: 'Envío deshabilitado fuera de Sandbox',
          color: 'warning',
        })
      }
      if (!this.chatActivo || !this.contentSid.trim()) return
      this.enviando = true
      try {
        await this.$http.post('twilio-sandbox.enviar', {
          to: this.chatActivo.peer,
          contentSid: this.contentSid.trim(),
          contentVariables: this.contentVariables,
        })
        await this.refrescarMensajes(true)
        await this.cargarChats(true)
      } catch (e) {
        const msg = (e.body && e.body.message) || (e.response && e.response.data && e.response.data.message) || 'Error al enviar plantilla'
        this.avisoSandbox( { text: msg, color: 'error' })
      } finally {
        this.enviando = false
      }
    },

    formatearFecha(value) {
      if (!value) return ''
      const d = new Date(value)
      if (Number.isNaN(d.getTime())) return String(value)
      return d.toLocaleString('es-MX', { hour: '2-digit', minute: '2-digit', day: '2-digit', month: '2-digit' })
    },
  },
}
</script>

<style scoped>
.wa-chat-list {
  flex: 1;
  overflow-y: auto;
  min-height: 0;
}
.wa-chat-active {
  background: #f0f2f5;
}
.wa-messages-panel {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  min-height: 0;
}
.wa-message-row {
  display: flex;
  margin-bottom: 8px;
}
.wa-message-in { justify-content: flex-start; }
.wa-message-out { justify-content: flex-end; }
.wa-bubble {
  max-width: 75%;
  padding: 8px 12px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 1px 1px rgba(0,0,0,.08);
}
.wa-message-out .wa-bubble {
  background: #d9fdd3;
}
.wa-bubble-meta {
  font-size: 10px;
  color: #667781;
  text-align: right;
  margin-top: 4px;
}
.wa-audio-badge {
  display: flex;
  align-items: center;
  gap: 4px;
  color: #3949ab;
  font-weight: 600;
}
.wa-draft-wa {
  white-space: pre-line;
  font-size: 13px;
  line-height: 1.4;
  background: #e8f5e9;
  border-radius: 6px;
  padding: 8px 10px;
}
.wa-compose-bar {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 2px;
  min-height: 36px;
  background: #f0f2f5;
  border-top: 1px solid #dce1e4;
}
.wa-compose-check {
  margin-right: 0 !important;
}
.wa-compose-check >>> .v-label {
  font-size: 11px;
}
.wa-role-toggle {
  flex-wrap: nowrap;
}
.wa-compose {
  display: flex;
  align-items: flex-end;
  gap: 8px;
  padding: 6px 10px;
  background: #f0f2f5;
  border-top: none;
}
.wa-compose-input {
  flex: 1;
}
.wa-ia-bar {
  display: flex;
  align-items: center;
  min-height: 36px;
  gap: 4px;
}
.wa-ia-title {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  color: #3949ab;
}
.wa-ia-agent {
  font-size: 12px;
  max-width: 42%;
  color: #546e7a;
}
.wa-ia-tabs {
  border-top: 1px solid #eef1f4;
}
.wa-ia-tabs-items {
  max-height: min(28vh, 220px);
  overflow-y: auto;
}
.wa-lab-scroll {
  max-height: min(26vh, 200px);
  overflow-y: auto;
}
.wa-draft-panel {
  border-top: 1px solid #dce1e4;
  background: #fafbfc;
  max-height: min(36vh, 280px);
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
}
.wa-draft-panel--min {
  max-height: 40px;
}
.wa-draft-box {
  background: #fff8e1;
  border: 1px solid #ffe082;
  border-radius: 8px;
  padding: 10px 12px;
}
.wa-draft-text {
  white-space: pre-line;
  font-size: 13px;
  line-height: 1.4;
}
.wa-contexto-box {
  background: #f5f7fa;
  border: 1px solid #e0e4ea;
  border-radius: 8px;
  padding: 10px 12px;
}
.wa-contexto-pre {
  margin: 0;
  font-size: 11px;
  background: #fff;
  border-radius: 6px;
  padding: 8px;
  max-height: min(22vh, 160px);
  overflow: auto;
}
.wa-contexto-msg {
  border-radius: 6px;
  padding: 6px 8px;
  margin-bottom: 6px;
  font-size: 12px;
}
.wa-contexto-lead {
  background: #fff;
  border-left: 3px solid #90caf9;
}
.wa-contexto-asesor {
  background: #e8f5e9;
  border-left: 3px solid #81c784;
}
.wa-contexto-msg-body {
  white-space: pre-line;
  margin-top: 2px;
}
.wa-empty-chat {
  min-height: 320px;
}
/* Header fijo: no dejar que botones extras se desborden y roben clics al panel */
.wa-chat-header {
  overflow: hidden;
  flex-wrap: nowrap;
  gap: 4px;
}
.sandbox-diagram-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.sandbox-node {
  padding: 12px 14px;
  border-radius: 8px;
  text-align: center;
  font-size: 13px;
  min-width: 120px;
  border: 1px solid #dce1e4;
}
.sandbox-node-user { background: #e8f5e9; }
.sandbox-node-twilio { background: #e3f2fd; }
.sandbox-node-api { background: #fff3e0; }
.sandbox-node-ui { background: #f3e5f5; }
.sandbox-arrow {
  font-size: 20px;
  color: #667781;
  font-weight: bold;
}
.sandbox-step {
  font-size: 13px;
  margin-bottom: 6px;
}
.sandbox-modes-table {
  border: 1px solid #e0e0e0;
  border-radius: 6px;
}
</style>
